import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table
} from "reactstrap";
import NoRecord from "../../../components/common/NoRecord";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

/**
 * @description component use for update/add location
 */
const LoansViewModal = ({
  title,
  showModel,
  _toggle,
  loans

}) => {
 

  return (
    <>
      <Modal isOpen={showModel} toggle={() => _toggle()} backdrop="static">
        <ModalHeader>
          {title}
          <Button color="link" onClick={() => _toggle()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 34 34"
            >
              <g data-name="Group 651" transform="translate(-1535 -134)">
                <g
                  fill="#fff"
                  stroke="#000"
                  strokeWidth="2"
                  data-name="Ellipse 30"
                  opacity="0.3"
                  transform="translate(1535 134)"
                >
                  <circle cx="17" cy="17" r="17" stroke="none"></circle>
                  <circle cx="17" cy="17" r="16" fill="none"></circle>
                </g>
                <path
                  d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                  data-name="Icon ionic-ios-close"
                  opacity="0.3"
                  transform="translate(1534.289 132.789)"
                ></path>
              </g>
            </svg>
          </Button>
        </ModalHeader>
        <ModalBody>

        {loans?.documentIds?.length && loans?.documentIds?.length !== 0
            ? <Table responsive>

            <thead>
              <tr>
                <th className='sort-heading'>
                  <div className="sort-elem-cell d-inline-flex align-items-center">
                    Document name
                  </div>
                </th>
                <th>Loan No.</th>
              </tr>
            </thead>
            <tbody>
              {
                loans.documentIds?.map((item, index) => {
                  return (
                    <tr>
                      <td>{item?.name} </td>
                      <td>{item?.loan_number} </td>     
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
            : loans?.documentIds?.length === 0 && <NoRecord />}


        </ModalBody>
       
      </Modal>
    </>
  );
};

export default LoansViewModal;
